import React from 'react'
import { useTranslation } from 'react-i18next'

import { Form, Text } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import Button from 'components/Button'
import { useMutation, updateQuery } from 'components/graphql'
import { createProductAddition, updateProductAddition } from '../../../gql/mutation'
import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'
import { notEmpty } from 'helpers/validators'
import cloneDeep from 'lodash/cloneDeep'

const AdditionDetails = ({ data = {}, listAdditionsQuery, closeForm }) => {
	const [t] = useTranslation()

	const isNewItem = data && !data.id
	const formVals = isNewItem ? { variants: new Array(10).fill('') } : data
	const mutation = isNewItem ? createProductAddition : updateProductAddition
	const [mutateProductAddition] = useMutation(mutation)
	const handleSubmit = vals => {
		const varName = isNewItem ? 'required' : 'fields'
		const mutationName = getNameOfGqlQuery(mutation)
		mutateProductAddition({
			variables: {
				...!isNewItem && { id: data.id },
				[varName]: cloneDeep(vals) // need to clone, original variants array gets weirdly modified otherwise
			},
			update: updateQuery({ query: listAdditionsQuery }, (draft, { mutationResult = {}, readQuery = [], queryField }) => {
				const newAdditions = isNewItem ?
					[...readQuery, mutationResult]
					: readQuery.map((item = {}) => Number(item.id) === Number(mutationResult.id) ? { ...item, mutationResult } : item)
				draft[queryField] = newAdditions
			}),
			optimisticResponse: {
				cashAssist: {
					[mutationName]: {
						id: isNewItem ? '-1' : data.id,
						...vals,
						__typename: 'ProductAddition'
					},
					__typename: 'CA_Mutation'
				}
			}
		})
		if(isNewItem && typeof closeForm === 'function') {
			closeForm()
		}
	}

	return(
		<ContentBlock related label={isNewItem ? t('common.strings.new') : formVals ? formVals.name : t('product_section.strings.name_not_provided')}>
			<Form
				key={formVals.id}
				initialValues={formVals}
				onSubmit={handleSubmit}
				reinitByModVer={false}
				smartSubmit={!isNewItem}
			>
				<Text
					field='name'
					label={t('product_section.fields.name')}
					{...notEmpty()}
					validateOnChange
				/>
				<div>
					<Text field={`variants[0]`} label={`${t('product_section.strings.variants')} 1-5`} shrink inline/>
					<Text field={`variants[1]`} shrink inline/>
					<Text field={`variants[2]`} shrink inline/>
					<Text field={`variants[3]`} shrink inline/>
					<Text field={`variants[4]`} shrink inline/>
					<br/>
					<Text field={`variants[5]`} label={`${t('product_section.strings.variants')} 6-10`} shrink inline/>
					<Text field={`variants[6]`} shrink inline/>
					<Text field={`variants[7]`} shrink inline/>
					<Text field={`variants[8]`} shrink inline/>
					<Text field={`variants[9]`} shrink inline/>
				</div>
				{isNewItem &&
					<Button type='submit' status='primary' text={t('common.buttons.save')} />
				}
			</Form>
		</ContentBlock>
	)
}

export default AdditionDetails
